export default __webpack_public_path__ + "static/media/logo.503af774.png";